import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJobRoles } from "./JobRolesAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobRolesAsync = createAsyncThunk(
  "JobRoles/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobRoles();

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobRolesSlice = createSlice({
  name: "JobRoles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobRolesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobRolesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchJobRolesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectJobRoles = (state) => state.jobRoles.data;

export default JobRolesSlice.reducer;
